import * as React from 'react';
import {Router, Route, Switch, RouteComponentProps} from 'react-router-dom';
import * as _ from 'lodash';
import {Spinner, SpinnerSize} from 'office-ui-fabric-react/lib/Spinner';
import {Home} from '../routes';
import { PathNames } from './PathNames';
import { IAccountInfo, IBookedForUsers } from './IMainApp';
import AppConfig from '../Constants';
import { MainHeader } from './Headers';
import PageNotFound from '../routes/PageNotFound';
import { createBrowserHistory } from "history";
import { IFilterData } from '../Components/ActivityGrid/ActivityGridFilters';

const history = createBrowserHistory();
const PlanActivity = React.lazy(() => import('../routes')
    .then(({ PlanActivity }) => {return ({ default: PlanActivity });}));
const CalendarMain = React.lazy(() => import('../Components/Calendar/CalendarMain'));
const Manage = React.lazy(() => import('../Components/Manage/Manage'));
const MyActivites = React.lazy(() => import('../routes')
    .then(({ MyActivites }) => {return ({ default: MyActivites });}));
const PlanOfficeSpace = React.lazy(() => import('../routes')
    .then(({ PlanOfficeSpace }) => {return ({ default: PlanOfficeSpace });}));
const PlanExperiment = React.lazy(() => import('../routes')
    .then(({ PlanExperiment }) => {return ({ default: PlanExperiment });}));

interface IAppRouteState{
    selectedKey: string;
    ActGridFilters: IFilterData;
}
interface IAppRouteProps{
    selectedKey: string;
    accountInfo:IAccountInfo;
}
export default class AppRoute extends React.Component<RouteComponentProps & IAppRouteProps,IAppRouteState>{
    constructor(props:RouteComponentProps &IAppRouteProps) {
        super(props);
        this.state={
            selectedKey: '0',
            ActGridFilters:{} as IFilterData
        };
    }
    componentDidMount(){
        var pathName = window.location.pathname;
        let selectedKey:string = this.getSelectedKeyFromConfig(pathName);
        this.setState({
            selectedKey
        });
    }
    getSelectedKeyFromConfig = (pathName:string):string =>{
        let selectedKey:string = '0';
        let filteredPathNames:any= _.filter(PathNames, {PathName:pathName});
        if(filteredPathNames.length>0){
            selectedKey = filteredPathNames[0].PathKey;
        }
        return selectedKey;
    }
    componentDidUpdate(prevProps:IAppRouteProps, prevState:IAppRouteState) {
        const {selectedKey} = this.props;
        if(prevProps.selectedKey!== selectedKey){
            this.setState({
                selectedKey
            });
        }
    }    
    handleClick = (selectedKey:any)=>{
        this.setState({
            selectedKey
        });
    }
    handleActGridFilterChange = (filteVaules:IFilterData) =>{
        this.setState({
            ActGridFilters:filteVaules
        });
    }
    render(){    
        const {selectedKey,ActGridFilters}:any = this.state;
        const {accountInfo}:any = this.props;
        return(
            <Router history={history}>
                <MainHeader
                        {...this.props}
                        iconName={AppConfig.Icons.appIconName}
                        appImageURL={AppConfig.Images.AppHeaderImage}
                        appLogoText={AppConfig.Headings.AppLogoText}
                        userDetail={accountInfo.account}
                        selectedKey={selectedKey}
                        handleRedirection={this.handleClick}
                    />
                <React.Suspense
                    fallback={
                        <div className="centeredContainer">
                            <Spinner size={SpinnerSize.large} />
                        </div>
                    }>
                    <Switch>
                        <Route exact path="/"  render={(props) =>  {return (<Home  handleRedirection={()=>this.handleClick('0')}/>)}} />
                        <Route path="/Home" render={(props) =>  {return (<Home   handleRedirection={()=>this.handleClick('0')}/>)}}  />
                        <Route path="/PlanActivity" render={(props) =>  {return (<PlanActivity {...props} handleRedirection={()=>this.handleClick('2')}/>)}}  />
                        <Route path="/PlanExperiment" render={(props) =>  {return (<PlanExperiment {...props} handleRedirection={()=>this.handleClick('1')}/>)}}  />
                        <Route path="/PlanOfficeSpace" render={(props) =>  {return (<PlanOfficeSpace {...props} handleRedirection={()=>this.handleClick('3')}/>)}}  />
                        <Route path="/Calendar" render={(props) =>  {return (<CalendarMain {...props} handleRedirection={()=>this.handleClick('4')}/>)}} />
                        <Route path="/MyActivities" render={(props) =>  {return (<MyActivites {...props} filterValues={ActGridFilters} 
                            handleFilterChange ={this.handleActGridFilterChange} handleRedirection={()=>this.handleClick('5')}/>)}} />
                        <Route path="/Manage" render={(props) =>  {return (<Manage {...props} handleRedirection={()=>this.handleClick('6')}/>)}} />
                        <Route component={PageNotFound} />
                    </Switch>
                </React.Suspense>
            </Router>
        ); 
    }    
};


